import { range, remap } from 'math'
import { KNOB_SIZE, KNOB_STEP_WIDTH, RAIL_COLOR, RAIL_INSET_SHADOW } from '../constants'
import type { KnobLine } from '../types'
import type { Ref } from 'vue'
import type { RenderLinesProps } from './types'



const renderStepLines_v1 = (_lines: Ref<KnobLine[]>, props: RenderLinesProps) => {
  const lineHeight = KNOB_SIZE * 1.5
  const stepMod = props.range.appearance?.stepMod

  const st = props.range.step || 0
  const w = Math.max(1, props.bounds.max.x)
  const rw = (props.range.max || 0) - (props.range.min || 0)
  const numVertical = st > 0 && rw > 0 ? Math.ceil(rw / st) : 0

  return range(numVertical).map((i) => {
    if (stepMod && i % stepMod !== 0) {
      return <div />
    }
    const n = i / numVertical
    const x = remap(n * rw, { min: 0, max: rw }, { min: 0, max: w })
    const y = - lineHeight / 2;

    return <div class='rounded-sm' style={{
      position: 'absolute',
      width: KNOB_STEP_WIDTH + 'px',
      height: lineHeight + 'px',
      background: RAIL_COLOR,
      left: x + 'px',
      top: y + 'px',
      opacity: '40%',
      boxShadow: RAIL_INSET_SHADOW
    }}/>
  })
}

export const renderStepLines = (lines: Ref<KnobLine[]>, props: RenderLinesProps) => {
  return renderStepLines_v1(lines, props)
}
